import AchDepositForm from "components/transactions/ach_deposit_form";
import LinkPlaidInstantly from "components/bank_accounts/link_plaid_instantly";
import WithdrawalConfirmationModal from "components/transactions/withdrawal_confirmation_modal";

$(() => {
  new Vue({
    el: document.querySelector(".v-bank-accounts-settings-controller"),
    components: { LinkPlaidInstantly, AchDepositForm, WithdrawalConfirmationModal },
  });
});
